import StatCard from '../../../components/StatCard';
import React from 'react';
import {useSalesNet} from '../hook/useSalesNet';

const SalesNet = ({ salesNetModel }: {salesNetModel: {salesNet: number, totalTransactions: number}}) => {

  const { statSalesNet } = useSalesNet(salesNetModel)
  return (
    <StatCard title="Ventas" icon="Information" stats={statSalesNet} />
  )
}

export default SalesNet
